"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _categoryApi = require("@/api/categoryApi");
var _store = require("@/api/store");
var _shopIntegralApi = require("@/api/shopIntegralApi");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
function createGoodsQuery() {
  return {
    skuId: '',
    skuCode: '',
    skuName: '',
    brandId: null,
    supplierId: null,
    category: null,
    sortKey: 'updateTime_desc'
  };
}
var _default = exports.default = {
  name: 'GoodsManageContent',
  props: {
    activityId: {
      type: [String, Number],
      default: ''
    },
    activityType: {
      type: Number,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      brandOptions: [],
      supplierOptions: [],
      categoryTreeOptions: [],
      categoryCascaderProps: {
        value: 'id',
        label: 'name',
        children: 'child',
        checkStrictly: true,
        emitPath: false
      },
      mainGoodsQuery: createGoodsQuery(),
      batchGoodsQuery: createGoodsQuery(),
      mainGoodsList: [],
      batchGoodsList: [],
      mainGoodsTotal: 0,
      batchGoodsTotal: 0,
      mainGoodsListLoading: false,
      batchGoodsListLoading: false,
      importBatchId: null,
      mainGoodsPagination: {
        page: 1,
        limit: 10
      },
      batchGoodsPagination: {
        page: 1,
        limit: 10
      },
      batchDialogVisible: false,
      batchSubmitLoading: false,
      batchCancelLoading: false,
      importDialogVisible: false,
      importFileName: '',
      importFileRaw: null,
      importSubmitLoading: false
    };
  },
  computed: {
    templateFileName: function templateFileName() {
      return '商品导入模板.xlsx';
    },
    hasMainGoodsFilterActive: function hasMainGoodsFilterActive() {
      return this.hasGoodsFilterActive(this.mainGoodsQuery);
    },
    showImportEmptyBlock: function showImportEmptyBlock() {
      return !this.readonly && !this.hasMainGoodsFilterActive && this.mainGoodsTotal <= 0;
    },
    hasBatchGoodsFilterActive: function hasBatchGoodsFilterActive() {
      return this.hasGoodsFilterActive(this.batchGoodsQuery);
    },
    showBatchImportEmptyBlock: function showBatchImportEmptyBlock() {
      return !this.readonly && !this.hasBatchGoodsFilterActive && this.batchGoodsTotal <= 0;
    }
  },
  watch: {
    activityId: {
      immediate: true,
      handler: function handler(val) {
        if (val) this.onOpen();else {
          this.importBatchId = null;
          this.mainGoodsList = [];
          this.mainGoodsTotal = 0;
        }
      }
    },
    activityType: function activityType() {
      var allowedSortKeys = new Set(['updateTime_desc', 'updateTime_asc', 'defaultPrice_desc', 'defaultPrice_asc']);
      if (!allowedSortKeys.has(String(this.mainGoodsQuery.sortKey || ''))) this.mainGoodsQuery.sortKey = 'updateTime_desc';
      if (!allowedSortKeys.has(String(this.batchGoodsQuery.sortKey || ''))) this.batchGoodsQuery.sortKey = 'updateTime_desc';
      if (this.activityId) this.onOpen();
    }
  },
  created: function created() {
    this.loadCategoryTree();
  },
  methods: {
    onOpen: function onOpen() {
      this.mainGoodsPagination.page = 1;
      this.loadMainGoodsList();
    },
    clearImportBatchId: function clearImportBatchId() {
      this.importBatchId = null;
    },
    hasGoodsFilterActive: function hasGoodsFilterActive(query) {
      var q = query || {};
      return Boolean((q.skuId || '').trim() || (q.skuCode || '').trim() || (q.skuName || '').trim() || q.brandId != null && q.brandId !== '' || q.supplierId != null && q.supplierId !== '' || q.category != null && q.category !== '');
    },
    mapProductRow: function mapProductRow(item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        goodsName: item.skuName,
        brand: item.brandName,
        supplier: item.supplierName,
        firstCategory: item.categoryName1,
        secondCategory: item.categoryName2,
        thirdCategory: item.categoryName3,
        pointsInfo: '—',
        enablePoints: item.isReturnIntegral === 1 ? '是' : item.isReturnIntegral === 0 ? '否' : '—',
        platformStatusDesc: item.platformStatusDesc != null && item.platformStatusDesc !== '' ? item.platformStatusDesc : item.platformStatus
      });
    },
    parseGoodsSortKey: function parseGoodsSortKey(sortKey) {
      var allowedSortFields = new Set(['updateTime', 'defaultPrice']);
      var raw = sortKey != null && String(sortKey).trim() !== '' ? String(sortKey).trim() : 'updateTime_desc';
      var parts = raw.split('_');
      var tail = parts.length > 1 ? parts[parts.length - 1] : 'desc';
      var sortType = tail === 'asc' ? 'asc' : 'desc';
      var sortField = parts.length > 1 ? parts.slice(0, -1).join('_') : raw;
      return {
        sortField: allowedSortFields.has(sortField) ? sortField : 'updateTime',
        sortType: sortType
      };
    },
    buildProductPageBody: function buildProductPageBody(query, batchId) {
      var body = {
        activityId: this.activityId,
        activityType: this.activityType
      };
      if (batchId != null && batchId !== '') body.batchId = batchId;
      var skuIdStr = (query.skuId || '').trim();
      if (skuIdStr && /^\d+$/.test(skuIdStr)) body.skuId = Number(skuIdStr);
      var skuCode = (query.skuCode || '').trim();
      if (skuCode) body.skuCode = skuCode;
      var skuName = (query.skuName || '').trim();
      if (skuName) body.skuName = skuName;
      if (query.brandId != null && query.brandId !== '') body.brandId = query.brandId;
      if (query.supplierId != null && query.supplierId !== '') body.supplierId = query.supplierId;
      if (query.category != null && query.category !== '') body.cateId = query.category;
      var _this$parseGoodsSortK = this.parseGoodsSortKey(query.sortKey),
        sortField = _this$parseGoodsSortK.sortField,
        sortType = _this$parseGoodsSortK.sortType;
      body.sortField = sortField;
      body.sortType = sortType;
      return body;
    },
    loadGoodsList: function () {
      var _loadGoodsList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var options,
          isBatch,
          query,
          pagination,
          batchId,
          data,
          list,
          total,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              isBatch = !!options.isBatch;
              query = isBatch ? this.batchGoodsQuery : this.mainGoodsQuery;
              pagination = isBatch ? this.batchGoodsPagination : this.mainGoodsPagination;
              batchId = isBatch ? this.importBatchId : null;
              if (!(!this.activityId || this.activityType == null || isBatch && (batchId == null || batchId === ''))) {
                _context.n = 1;
                break;
              }
              if (isBatch) {
                this.batchGoodsList = [];
                this.batchGoodsTotal = 0;
              } else {
                this.mainGoodsList = [];
                this.mainGoodsTotal = 0;
              }
              return _context.a(2);
            case 1:
              if (isBatch) this.batchGoodsListLoading = true;else this.mainGoodsListLoading = true;
              _context.p = 2;
              _context.n = 3;
              return (0, _shopIntegralApi.shopIntegralActivityProductPageApi)({
                page: pagination.page,
                limit: pagination.limit
              }, this.buildProductPageBody(query, batchId));
            case 3:
              data = _context.v;
              list = data && data.list || [];
              total = data && data.total != null ? Number(data.total) : list.length;
              if (isBatch) {
                this.batchGoodsList = list.map(function (row) {
                  return _this.mapProductRow(row);
                });
                this.batchGoodsTotal = total;
              } else {
                this.mainGoodsList = list.map(function (row) {
                  return _this.mapProductRow(row);
                });
                this.mainGoodsTotal = total;
              }
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              if (isBatch) {
                this.batchGoodsList = [];
                this.batchGoodsTotal = 0;
              } else {
                this.mainGoodsList = [];
                this.mainGoodsTotal = 0;
              }
            case 5:
              _context.p = 5;
              if (isBatch) this.batchGoodsListLoading = false;else this.mainGoodsListLoading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function loadGoodsList() {
        return _loadGoodsList.apply(this, arguments);
      }
      return loadGoodsList;
    }(),
    loadMainGoodsList: function loadMainGoodsList() {
      return this.loadGoodsList({
        isBatch: false
      });
    },
    loadBatchGoodsList: function loadBatchGoodsList() {
      return this.loadGoodsList({
        isBatch: true
      });
    },
    handleMainGoodsQuery: function handleMainGoodsQuery() {
      this.mainGoodsPagination.page = 1;
      this.loadMainGoodsList();
    },
    resetMainGoodsFilter: function resetMainGoodsFilter() {
      this.mainGoodsQuery = createGoodsQuery();
      this.mainGoodsPagination.page = 1;
      this.loadMainGoodsList();
    },
    handleBatchGoodsQuery: function handleBatchGoodsQuery() {
      this.batchGoodsPagination.page = 1;
      this.loadBatchGoodsList();
    },
    resetBatchGoodsFilter: function resetBatchGoodsFilter() {
      this.batchGoodsQuery = createGoodsQuery();
      this.batchGoodsPagination.page = 1;
      this.loadBatchGoodsList();
    },
    loadCategoryTree: function () {
      var _loadCategoryTree = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t2, _t3;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _categoryApi.treeCategroy)({
                type: 1,
                status: -1
              });
            case 1:
              _t2 = _context2.v;
              if (_t2) {
                _context2.n = 2;
                break;
              }
              _t2 = [];
            case 2:
              this.categoryTreeOptions = _t2;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t3 = _context2.v;
              this.categoryTreeOptions = [];
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 3]]);
      }));
      function loadCategoryTree() {
        return _loadCategoryTree.apply(this, arguments);
      }
      return loadCategoryTree;
    }(),
    fetchBrandOptions: function () {
      var _fetchBrandOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(keyword) {
        var _t4, _t5;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _store.getBrandrApi)({
                keyword: keyword != null ? keyword : ''
              });
            case 1:
              _t4 = _context3.v;
              if (_t4) {
                _context3.n = 2;
                break;
              }
              _t4 = [];
            case 2:
              this.brandOptions = _t4;
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t5 = _context3.v;
              this.brandOptions = [];
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 3]]);
      }));
      function fetchBrandOptions(_x) {
        return _fetchBrandOptions.apply(this, arguments);
      }
      return fetchBrandOptions;
    }(),
    fetchSupplierOptions: function () {
      var _fetchSupplierOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(keyword) {
        var _t6, _t7;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _store.getSupplierApi)({
                keyword: keyword != null ? keyword : ''
              });
            case 1:
              _t6 = _context4.v;
              if (_t6) {
                _context4.n = 2;
                break;
              }
              _t6 = [];
            case 2:
              this.supplierOptions = _t6;
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t7 = _context4.v;
              this.supplierOptions = [];
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 3]]);
      }));
      function fetchSupplierOptions(_x2) {
        return _fetchSupplierOptions.apply(this, arguments);
      }
      return fetchSupplierOptions;
    }(),
    brandRemoteMethod: function brandRemoteMethod(query) {
      this.fetchBrandOptions(query);
    },
    supplierRemoteMethod: function supplierRemoteMethod(query) {
      this.fetchSupplierOptions(query);
    },
    onBrandVisibleChange: function onBrandVisibleChange(visible) {
      if (visible) this.fetchBrandOptions('');
    },
    onSupplierVisibleChange: function onSupplierVisibleChange(visible) {
      if (visible) this.fetchSupplierOptions('');
    },
    handleSkuIdInput: function handleSkuIdInput(queryKey) {
      var targetQuery = this[queryKey];
      if (!targetQuery) return;
      var rawValue = targetQuery.skuId == null ? '' : String(targetQuery.skuId);
      var digitsOnly = rawValue.replace(/\D/g, '');
      targetQuery.skuId = digitsOnly.replace(/^0+(\d+)/, '$1').replace(/^0$/, '');
    },
    handleMainGoodsPageChange: function handleMainGoodsPageChange(page) {
      this.mainGoodsPagination.page = page;
      this.loadMainGoodsList();
    },
    handleMainGoodsSizeChange: function handleMainGoodsSizeChange(limit) {
      this.mainGoodsPagination.limit = limit;
      this.mainGoodsPagination.page = 1;
      this.loadMainGoodsList();
    },
    handleBatchGoodsPageChange: function handleBatchGoodsPageChange(page) {
      this.batchGoodsPagination.page = page;
      this.loadBatchGoodsList();
    },
    handleBatchGoodsSizeChange: function handleBatchGoodsSizeChange(limit) {
      this.batchGoodsPagination.limit = limit;
      this.batchGoodsPagination.page = 1;
      this.loadBatchGoodsList();
    },
    removeGoods: function () {
      var _removeGoods = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row, isBatch) {
        var confirmText, payload, _t8, _t9;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(!row || row.id == null || row.id === '')) {
                _context5.n = 1;
                break;
              }
              this.$message.warning('缺少商品主键，无法移除');
              return _context5.a(2);
            case 1:
              confirmText = isBatch ? '确定从导入活动商品列表中移除该商品吗？' : '确定从活动商品列表中移除该商品吗？';
              _context5.p = 2;
              _context5.n = 3;
              return this.$confirm(confirmText, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 3:
              _context5.n = 5;
              break;
            case 4:
              _context5.p = 4;
              _t8 = _context5.v;
              return _context5.a(2);
            case 5:
              _context5.p = 5;
              payload = {
                id: row.id
              };
              if (isBatch && this.importBatchId != null && this.importBatchId !== '') payload.batchId = this.importBatchId;
              _context5.n = 6;
              return (0, _shopIntegralApi.shopIntegralActivityProductDeleteByIdApi)(payload);
            case 6:
              this.$message.success('移除成功');
              if (!isBatch) {
                _context5.n = 8;
                break;
              }
              _context5.n = 7;
              return this.loadBatchGoodsList();
            case 7:
              _context5.n = 9;
              break;
            case 8:
              _context5.n = 9;
              return this.loadMainGoodsList();
            case 9:
              _context5.n = 11;
              break;
            case 10:
              _context5.p = 10;
              _t9 = _context5.v;
            case 11:
              return _context5.a(2);
          }
        }, _callee5, this, [[5, 10], [2, 4]]);
      }));
      function removeGoods(_x3, _x4) {
        return _removeGoods.apply(this, arguments);
      }
      return removeGoods;
    }(),
    openBatchDialog: function openBatchDialog() {
      if (this.readonly) return;
      this.clearImportBatchId();
      this.batchGoodsQuery = createGoodsQuery();
      this.batchGoodsPagination.page = 1;
      this.batchGoodsList = [];
      this.batchGoodsTotal = 0;
      this.batchDialogVisible = true;
    },
    onBatchDialogOpen: function onBatchDialogOpen() {
      this.batchGoodsPagination.page = 1;
      if (this.importBatchId != null && this.importBatchId !== '') this.loadBatchGoodsList();else {
        this.batchGoodsList = [];
        this.batchGoodsTotal = 0;
      }
    },
    openImportDialog: function openImportDialog() {
      if (!this.readonly) this.importDialogVisible = true;
    },
    resetImportDialog: function resetImportDialog() {
      var _this2 = this;
      this.importFileName = '';
      this.importFileRaw = null;
      this.importSubmitLoading = false;
      this.$nextTick(function () {
        if (_this2.$refs.importUpload) _this2.$refs.importUpload.clearFiles();
      });
    },
    handleDownloadTemplate: function () {
      var _handleDownloadTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var fileName, res, _t0;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              fileName = Number(this.activityType) === 1 ? 'integral_gave_product_tmp.xlsx' : 'integral_exchange_product_tmp.xlsx';
              _context6.p = 1;
              _context6.n = 2;
              return (0, _shopIntegralApi.exportIntegralProductTemplateApi)(fileName);
            case 2:
              res = _context6.v;
              window.open(res.fileName, '_blank');
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t0 = _context6.v;
              this.$message.error('下载模板失败');
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this, [[1, 3]]);
      }));
      function handleDownloadTemplate() {
        return _handleDownloadTemplate.apply(this, arguments);
      }
      return handleDownloadTemplate;
    }(),
    handleImportFileChange: function handleImportFileChange(file) {
      var _this3 = this;
      var raw = file && file.raw;
      if (!raw) return;
      var ext = (raw.name || '').split('.').pop().toLowerCase();
      if (!['xls', 'xlsx'].includes(ext)) {
        this.$message.warning('仅支持 .xls / .xlsx 文件');
        this.importFileName = '';
        this.importFileRaw = null;
        this.$nextTick(function () {
          if (_this3.$refs.importUpload) _this3.$refs.importUpload.clearFiles();
        });
        return;
      }
      this.importFileRaw = raw;
      this.importFileName = raw.name;
    },
    handleRemoveImportFile: function handleRemoveImportFile() {
      var _this4 = this;
      this.importFileName = '';
      this.importFileRaw = null;
      this.$nextTick(function () {
        if (_this4.$refs.importUpload) _this4.$refs.importUpload.clearFiles();
      });
    },
    cancelPendingBatch: function () {
      var _cancelPendingBatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var showMessage,
          batchId,
          _args7 = arguments;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              showMessage = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : true;
              batchId = this.importBatchId;
              if (!(!this.activityId || batchId == null || batchId === '')) {
                _context7.n = 1;
                break;
              }
              this.clearImportBatchId();
              this.batchGoodsList = [];
              this.batchGoodsTotal = 0;
              return _context7.a(2, false);
            case 1:
              _context7.n = 2;
              return (0, _shopIntegralApi.shopIntegralActivityProductCancelImportBatchApi)({
                activityId: Number(this.activityId),
                activityType: this.activityType,
                batchId: batchId
              });
            case 2:
              this.clearImportBatchId();
              this.batchGoodsList = [];
              this.batchGoodsTotal = 0;
              if (showMessage) this.$message.success('已取消导入批次');
              return _context7.a(2, true);
          }
        }, _callee7, this);
      }));
      function cancelPendingBatch() {
        return _cancelPendingBatch.apply(this, arguments);
      }
      return cancelPendingBatch;
    }(),
    handleCancelBatch: function () {
      var _handleCancelBatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              if (!(this.importBatchId == null || this.importBatchId === '')) {
                _context8.n = 1;
                break;
              }
              this.batchDialogVisible = false;
              return _context8.a(2);
            case 1:
              this.batchCancelLoading = true;
              _context8.p = 2;
              _context8.n = 3;
              return this.cancelPendingBatch(true);
            case 3:
              this.batchDialogVisible = false;
            case 4:
              _context8.p = 4;
              this.batchCancelLoading = false;
              return _context8.f(4);
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this, [[2,, 4, 5]]);
      }));
      function handleCancelBatch() {
        return _handleCancelBatch.apply(this, arguments);
      }
      return handleCancelBatch;
    }(),
    handleBatchDialogBeforeClose: function () {
      var _handleBatchDialogBeforeClose = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(done) {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              if (!this.batchCancelLoading) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              if (!(this.importBatchId == null || this.importBatchId === '')) {
                _context9.n = 2;
                break;
              }
              done();
              return _context9.a(2);
            case 2:
              this.batchCancelLoading = true;
              _context9.p = 3;
              _context9.n = 4;
              return this.cancelPendingBatch(true);
            case 4:
              done();
            case 5:
              _context9.p = 5;
              this.batchCancelLoading = false;
              return _context9.f(5);
            case 6:
              return _context9.a(2);
          }
        }, _callee9, this, [[3,, 5, 6]]);
      }));
      function handleBatchDialogBeforeClose(_x5) {
        return _handleBatchDialogBeforeClose.apply(this, arguments);
      }
      return handleBatchDialogBeforeClose;
    }(),
    handleSubmitBatch: function () {
      var _handleSubmitBatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var msg;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              if (this.activityId) {
                _context0.n = 1;
                break;
              }
              this.$message.warning('缺少活动信息，无法提交');
              return _context0.a(2);
            case 1:
              if (!(this.importBatchId == null || this.importBatchId === '')) {
                _context0.n = 2;
                break;
              }
              this.$message.warning('请先完成商品导入后再提交');
              return _context0.a(2);
            case 2:
              this.batchSubmitLoading = true;
              _context0.p = 3;
              _context0.n = 4;
              return (0, _shopIntegralApi.shopIntegralActivityProductSubmitImportBatchApi)({
                activityId: Number(this.activityId),
                activityType: this.activityType,
                batchId: this.importBatchId
              });
            case 4:
              msg = _context0.v;
              this.$message.success(typeof msg === 'string' && msg ? msg : '提交成功');
              this.clearImportBatchId();
              this.batchDialogVisible = false;
              this.batchGoodsList = [];
              this.batchGoodsTotal = 0;
              this.mainGoodsPagination.page = 1;
              _context0.n = 5;
              return this.loadMainGoodsList();
            case 5:
              _context0.p = 5;
              this.batchSubmitLoading = false;
              return _context0.f(5);
            case 6:
              return _context0.a(2);
          }
        }, _callee0, this, [[3,, 5, 6]]);
      }));
      function handleSubmitBatch() {
        return _handleSubmitBatch.apply(this, arguments);
      }
      return handleSubmitBatch;
    }(),
    handleConfirmImport: function () {
      var _handleConfirmImport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var data, rawRepeats, repeatSkuIds, skuLine, msg, hasResponse, hasBusinessMessage, _t1, _t10;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              if (this.activityId) {
                _context1.n = 1;
                break;
              }
              this.$message.warning('缺少活动信息，无法导入');
              return _context1.a(2);
            case 1:
              if (this.importFileRaw) {
                _context1.n = 2;
                break;
              }
              this.$message.warning('请先选择导入文件');
              return _context1.a(2);
            case 2:
              this.importSubmitLoading = true;
              _context1.p = 3;
              _context1.n = 4;
              return (0, _shopIntegralApi.shopIntegralActivityProductImportApi)({
                activityId: this.activityId,
                activityType: this.activityType,
                file: this.importFileRaw,
                batchId: this.importBatchId
              });
            case 4:
              data = _context1.v;
              if (data && data.batchId != null) {
                this.importBatchId = Number(data.batchId);
              }
              rawRepeats = data && (data.repeatSkuIds != null ? data.repeatSkuIds : data.repeats);
              repeatSkuIds = Array.isArray(rawRepeats) ? rawRepeats : [];
              if (!repeatSkuIds.length) {
                _context1.n = 10;
                break;
              }
              skuLine = repeatSkuIds.map(function (id) {
                return String(id);
              }).join('、');
              msg = "\u68C0\u6D4B\u5230\u672C\u6B21\u6279\u91CF\u4E0A\u4F20\u7684\u5546\u54C1\u4E0E\u73B0\u6709\u5546\u54C1\u4FE1\u606F\u91CD\u590D\uFF0C\u662F\u5426\u786E\u8BA4\u5BF9\u91CD\u590D\u5546\u54C1\u6267\u884C\u8986\u76D6\u66F4\u65B0\uFF1F\n\u4EE5\u4E0B\u4E3A\u91CD\u590D\u5546\u54C1\u5BF9\u5E94\u7684 skuId\uFF1A\n".concat(skuLine);
              _context1.p = 5;
              _context1.n = 6;
              return this.$confirm(msg, '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 6:
              _context1.n = 9;
              break;
            case 7:
              _context1.p = 7;
              _t1 = _context1.v;
              _context1.n = 8;
              return this.cancelPendingBatch(false);
            case 8:
              this.importDialogVisible = false;
              this.resetImportDialog();
              return _context1.a(2);
            case 9:
              _context1.n = 11;
              break;
            case 10:
              this.$message.success('导入成功');
            case 11:
              this.importDialogVisible = false;
              this.resetImportDialog();
              this.batchDialogVisible = true;
              this.batchGoodsPagination.page = 1;
              _context1.n = 12;
              return this.loadBatchGoodsList();
            case 12:
              this.$emit('import-success');
              _context1.n = 14;
              break;
            case 13:
              _context1.p = 13;
              _t10 = _context1.v;
              hasResponse = !!(_t10 && _t10.response);
              hasBusinessMessage = !!(_t10 && _t10.message && _t10.message !== 'Network Error');
              if (!hasResponse && !hasBusinessMessage) {
                this.$message.warning('导入失败，文件可能已被修改，请重新选择后再导入');
              }
            case 14:
              _context1.p = 14;
              this.importSubmitLoading = false;
              return _context1.f(14);
            case 15:
              return _context1.a(2);
          }
        }, _callee1, this, [[5, 7], [3, 13, 14, 15]]);
      }));
      function handleConfirmImport() {
        return _handleConfirmImport.apply(this, arguments);
      }
      return handleConfirmImport;
    }()
  }
};